module.exports = __webpack_public_path__ + "img/cert2.7e86c657.jpg";